<template>
  <!-- Could make this nav a component later -->
<div id="app">
  <router-view/>
</div>
</template>

<script>
import Modal from './components/ContactModal.vue'

export default {
  name: 'CyberKiln Website',
  components: {
  },
   data() {
    return {
      isModalVisible: false,
    };
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
  },
}

</script>

<style lang="scss">

@import "@/styles/style.scss";

@font-face {
    font-family: 'PHHFont';
    src: url('~@/assets/fonts/acherus_militant_1_-_light.otf.otf');
}

// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   margin-top: 60px;
// }

// /* Should this be in a css file that we import */
// h1{
//   border-bottom: 1px solid #ddd;
//   display: inline-block;
//   padding-bottom: 10px;
// }
</style>
